var render = function render(){
  var _vm$courseFullTitle;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderContent', {
    attrs: {
      "pageTitle": _vm.pageTitle,
      "subText": `Project Spectrum offers comprehensive courses from CMMC Levels and FOCI through Encite. Explore our resources to learn how they play a vital role in enhancing your organization's cybersecurity posture.<br><br>To access Project Spectrum's online courses, you must log into the Encite learning management platform.`,
      "route": 'online-courses',
      "backButtonText": 'Back To All Online Courses',
      "desktopSubTitleWidth": '45%',
      "mobileSubTitleWidth": '85%'
    }
  })], 1), _c('section', {
    staticClass: "section p-0 mt-5 mb-4 section-content"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1"
  }, [!_vm.isLoggedIn ? _c('div', {
    staticClass: "my-2 d-flex align-items-center",
    staticStyle: {
      "min-height": "200px"
    }
  }, [_c('p', {
    staticClass: "access-text"
  }, [_vm._v(" " + _vm._s(`To access the ${_vm.courseTitle} courses you must first be logged into the Online Courses page`) + ". ")])]) : _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center mb-4"
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-center align-items-center",
    staticStyle: {
      "width": "90%"
    }
  }, [_c('p', {
    staticClass: "m-0 sub-title-text"
  }, [_vm._v("START LEARNING")]), _c('p', {
    staticClass: "m-0 main-title-text"
  }, [_vm._v(_vm._s((_vm$courseFullTitle = _vm.courseFullTitle) !== null && _vm$courseFullTitle !== void 0 ? _vm$courseFullTitle : _vm.courseTitle))])])]), _c('div', {
    staticClass: "container mb-4"
  }, [_c('EnciteCourseCredential')], 1), _c('div', {
    staticClass: "information-card-container"
  }, _vm._l(_vm.displayedItems, function (item) {
    return _c('InformationCard', {
      key: item.id,
      attrs: {
        "title": item.name,
        "description": item.description,
        "backgroundColor": _vm.informationCardColor,
        "textColor": _vm.informationCardTextColor,
        "buttonTitle": 'Start',
        "toLink": item.link
      }
    });
  }), 1), _vm.totalRows > _vm.perPage ? _c('div', [_c('b-pagination', {
    attrs: {
      "id": "blog-pagination",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "page-click": _vm.pageClicked
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }